const WHITE_LABEL_HOSTS = ['admin'];

export const isWhiteLabelAdmin = (): boolean => {
  return WHITE_LABEL_HOSTS.some((host) => window.location.hostname.includes(host));
};

export const WHITE_LABEL_HIDDEN_CODES = [
  'fmcsa',
  'sales',
  'user-companies',
  'owners',
  'supports',
  'logbook',
  'camera',
  'check-truck',
  'errors',
  'team',
  // Also matched against route paths (see filterRoutesForWhiteLabel): the External Integrations
  // menu group keeps the "team" code, but its pages now live under /external-integrations
  'external-integrations',
  'system-config',
  'weigh-station',
  'documents',
  'mobile',
  'globalSearch',
  'global-search',
  'find-by-uuid',
];

export const WHITE_LABEL_HIDDEN_COMPANY_TABS = [
  '2', // Stripe
  '3', // Subscription
  '4', // Subscription history
  '5', // Subscription update
  '6', // Contract
  '10', // IFTA
  '11', // Free trail
  '13', //Integration
  '14', //Integration
  '15', // Log Edit Access
  '16', // ELD Migration
];

export const WHITE_LABEL_HIDDEN_DRIVER_TABS = [
  '2', //Commands
  '3', // Config
  '4', // Logs
  '5', // Truck info
  '7', // Last Tracking
  '8', // Documents
  '9', // Tracking by range
  '10', // FMCSA Driver
  '11', //Malfunctions
  '12', // DOT Progress Details
];
